module.exports = __webpack_public_path__ + "img/product-3-min.114951d3.jpg";